var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.51802 5.46299L14.7864 2.70382C18.4989 1.46632 20.5155 3.49215 19.2872 7.20465L16.528 15.473C14.6764 21.0372 11.633 21.0372 9.78135 15.473L8.96552 13.0163L6.50885 12.2005C0.953855 10.358 0.953855 7.32382 6.51802 5.46299Z",
    fill: "#F4811E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 10.6604L14.6019 7.15878L11.1094 10.6604Z",
    fill: "#F69A4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.111 11.3479C10.9368 11.3479 10.7627 11.2838 10.6252 11.1463C10.3593 10.8804 10.3593 10.4404 10.6252 10.1746L14.1085 6.67295C14.3743 6.40711 14.8143 6.40711 15.0802 6.67295C15.346 6.93878 15.346 7.37878 15.0802 7.64461L11.5968 11.1463C11.4593 11.2746 11.2852 11.3479 11.111 11.3479Z",
    fill: "#F69A4B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOrange);
export default __webpack_public_path__ + "static/media/send-orange.388fb5f3e0114b2e2e135949fd1f7c7e.svg";
export { ForwardRef as ReactComponent };